import(/* webpackMode: "eager" */ "/home/runner/work/The-last-Gemini-/The-last-Gemini-/src/app/error.tsx");
